import { Controller } from '@hotwired/stimulus'
import { formatCurrency, parseCurrency } from './utils/currency_utils'
import { dispatcher } from './pub_controller'

export class VarianceFormController extends Controller {
  static targets = ['otherReasonInput', 'submitButton', 'billedAmount']
  static values = {
    selectedReasons: { type: String, default: '' },
  }

  declare readonly otherReasonInputTarget: HTMLElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly billedAmountTarget: HTMLInputElement
  declare selectedReasonsValue: string

  connect() {
    this.billedAmountTarget.addEventListener('input', () =>
      this.validateSubmittable(),
    )

    const hiddenInput = document.querySelector(
      '#invoice_service_offering_variance_reason-hidden',
    )
    if (hiddenInput instanceof HTMLInputElement && hiddenInput.value) {
      this.selectedReasonsValue = hiddenInput.value
    }

    const textarea = this.otherReasonInputTarget.querySelector('textarea')
    if (textarea && !textarea.dataset.listenerAdded) {
      textarea.addEventListener('input', () => this.validateSubmittable())
      textarea.dataset.listenerAdded = 'true'
    }

    const hasOther = this.selectedReasonsValue === 'other'
    this.otherReasonInputTarget.style.display = hasOther ? 'block' : 'none'

    this.validateSubmittable()
  }

  selectedReasonsValueChanged() {
    const hasOther = this.selectedReasonsValue === 'other'
    this.otherReasonInputTarget.style.display = hasOther ? 'block' : 'none'

    if (hasOther) {
      const textarea = this.otherReasonInputTarget.querySelector('textarea')
      textarea?.focus()
      if (textarea && !textarea.dataset.listenerAdded) {
        textarea.addEventListener('input', () => this.validateSubmittable())
        textarea.dataset.listenerAdded = 'true'
      }
    }

    this.validateSubmittable()
  }

  handleReasonChange(event: CustomEvent) {
    if (event.detail.value !== undefined) {
      this.selectedReasonsValue = event.detail.value || ''
    }
  }

  validateSubmittable() {
    const hasValidAmount = this.billedAmountTarget.value !== ''
    const hasValidSelection = this.selectedReasonsValue !== ''
    const hasOther = this.selectedReasonsValue === 'other'
    const textarea = this.otherReasonInputTarget.querySelector(
      'textarea',
    ) as HTMLTextAreaElement

    const hasValidOtherReason = hasOther
      ? textarea?.value.trim().length > 0
      : true

    this.submitButtonTarget.disabled = !(
      hasValidAmount &&
      hasValidSelection &&
      hasValidOtherReason
    )
  }

  validateSubmit(event: Event) {
    if (this.submitButtonTarget.disabled) {
      event.preventDefault()
      return
    }

    event.preventDefault()

    const serviceOfferingId = (this.element as HTMLElement).dataset
      .serviceOfferingId

    const billedAmount = this.billedAmountTarget.value
    const varianceReason = this.selectedReasonsValue
    const varianceComments =
      this.otherReasonInputTarget.querySelector('textarea')?.value || ''

    const detail = {
      service_offering_id: serviceOfferingId,
      billed_amount: billedAmount,
      variance_reason: varianceReason,
      variance_comments: varianceComments,
    }

    dispatcher(this, 'submit', 'variance', detail)

    const modal = document.querySelector('[data-controller="turbo-modal"]')
    if (modal) {
      const controller = (
        window as any
      ).Stimulus.getControllerForElementAndIdentifier(modal, 'turbo-modal')
      if (controller) {
        controller.updateProps({ open: false })
      }
    }

    return false
  }
}
